export function parseJwtPayload(token: string) {
  if (!token) return null;
  const parts = token.split('.');
  if (parts.length < 2) return null;
  try {
    const payload = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const padded = payload + '='.repeat((4 - (payload.length % 4)) % 4);
    const json = atob(padded);
    const parsed = JSON.parse(json);
    if (parsed && typeof parsed === 'object') {
      parsed.permissions = buildJwtPermissions(parsed);
    }
    return parsed;
  } catch {
    return null;
  }
}

export function buildJwtPermissions(payload: any) {
  const entries = Object.entries(payload || {}).reduce((acc, [key, value]) => {
    const match = key.match(/^PermittedRoleActions_(\d+)_(.+)$/);
    if (!match) return acc;

    const [, index, field] = match;
    const current = acc[index] || {};
    acc[index] = { ...current, [field]: value };
    return acc;
  }, {} as Record<string, Record<string, any>>);

  const actionEntries = Object.values(entries);
  const organizationId =
    actionEntries.find((entry) => entry?.OrganizationId != null)?.OrganizationId ?? null;
  const actions = Array.from(
    new Set(
      actionEntries
        .map((entry) => (typeof entry?.ActionName === 'string' ? entry.ActionName : null))
        .filter(Boolean)
    )
  );

  return {
    organizationId,
    actions,
  };
}

export function checkTokenExpiration(token: string, bufferMinutes = 5) {
  const payload = parseJwtPayload(token);
  if (!payload || !payload.exp) {
    return { isExpired: true, isExpiringSoon: true, expiresAt: null, minutesRemaining: 0 };
  }

  const expiresAt = new Date(payload.exp * 1000);
  const now = Date.now();
  const expiresAtMs = payload.exp * 1000;
  const minutesRemaining = Math.floor((expiresAtMs - now) / 60000);

  return {
    isExpired: now >= expiresAtMs,
    isExpiringSoon: minutesRemaining <= bufferMinutes,
    expiresAt,
    minutesRemaining: Math.max(0, minutesRemaining),
  };
}
